import React, { useRef, useState } from 'react';
import { Button, Select, Divider, Input } from '../';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { useNotificationContext } from '../../providers/NotificationProvider';

import './CreatableSelect.scss';

export const CreatableSelect = ({
    selectPlaceholder,
    addItemPlaceholder,
    options,
    onChange,
    value,
    disabled,
    mode,
    placement,
    tagRender,
}) => {
    const { notifyError } = useNotificationContext();
    const [selectOptions, setSelectOptions] = useState(options || []);
    const [addInputValue, setAddInputValue] = useState('');
    const inputRef = useRef(null);

    const addItem = (e) => {
        e.preventDefault();
        const newValue = addInputValue.trim();
        if (!newValue) return;

        // Check if an option with this name already exists (case-insensitive)
        const isDuplicate = selectOptions.some((option) => option.label.toLowerCase() === newValue.toLowerCase());

        if (isDuplicate) {
            notifyError({ message: `"${newValue}" already exists` });
            return;
        }

        setSelectOptions([
            ...selectOptions,
            {
                value: newValue,
                label: newValue,
            },
        ]);
        setAddInputValue('');
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };
    return (
        <div className="creatable-select-container">
            <Select
                getPopupContainer={(trigger) => trigger.parentElement}
                className="creatable-select"
                showSearch={{
                    optionFilterProp: 'label',
                    filterSort: (optionA, optionB) =>
                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase()),
                }}
                suffixIcon={<SearchOutlined />}
                onChange={onChange}
                value={value}
                disabled={disabled}
                mode={mode}
                placement={placement}
                tagRender={tagRender}
                placeholder={selectPlaceholder}
                options={selectOptions}
                popupRender={(menu) => (
                    <>
                        {menu}
                        <Divider className="creatable-select-divider" />
                        <div className="creatable-select-add-item">
                            <Input
                                placeholder={addItemPlaceholder}
                                ref={inputRef}
                                value={addInputValue}
                                onChange={(e) => setAddInputValue(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                Add item
                            </Button>
                        </div>
                    </>
                )}
            />
        </div>
    );
};
